import styled, { css } from "styled-components";
import { CircularProgress } from "@mui/material";

interface ColorCircularProgressProps {
  customColor?: ReturnType<typeof css>;
}

const ColoredCircularProgress = styled(CircularProgress).withConfig({
  shouldForwardProp: (prop) => !["customColor"].includes(prop),
})<ColorCircularProgressProps>`
  ${({ customColor }) => {
    let colorOut = css`"none"`;
    if (customColor) {
      colorOut = customColor;
    }

    return css`
      color: ${colorOut};
    `;
  }}
`;

export default ColoredCircularProgress;
